const Send = ({ size = 20, color = 'currentColor', ...other }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...other}
    >
      <path
        d="M8.76785 11.8481C8.61075 11.8481 8.45366 11.7865 8.33352 11.6664C8.09325 11.4261 8.09325 11.0349 8.33352 10.7947L17.1125 2.01565C17.3528 1.77538 17.744 1.77538 17.9843 2.01565C18.2245 2.25592 18.2245 2.64712 17.9843 2.88739L9.20526 11.6664C9.08513 11.7865 8.92803 11.8481 8.77093 11.8481H8.76785Z"
        fill={color}
      />
      <path
        d="M11.9869 18.625C11.2476 18.625 10.613 18.1784 10.3728 17.4884L8.41364 11.8667C8.36744 11.7312 8.26579 11.6326 8.13025 11.5833L2.5086 9.6242C1.8186 9.38393 1.37195 8.74938 1.37195 8.01009C1.37195 7.21536 1.88329 6.5038 2.64106 6.23889L16.3086 1.47974C16.9586 1.25487 17.6547 1.40581 18.126 1.87402C18.5973 2.34532 18.7482 3.04148 18.5203 3.69143L13.7581 17.3559C13.4932 18.1167 12.7816 18.625 11.9869 18.625ZM16.5119 2.05884L16.7152 2.64103L3.05074 7.40634C2.72422 7.52032 2.60717 7.80371 2.60717 8.01317C2.60717 8.13947 2.64722 8.36741 2.91829 8.46291L8.53994 10.422C9.02972 10.5914 9.4086 10.9734 9.5811 11.4632L11.5402 17.0848C11.6357 17.3559 11.8636 17.3959 11.9899 17.3959C12.1994 17.3959 12.4828 17.2789 12.5968 16.9524L17.359 3.28791C17.4607 2.99527 17.322 2.81353 17.2573 2.74884C17.1927 2.68416 17.0109 2.54554 16.7183 2.64719L16.515 2.065L16.5119 2.05884Z"
        fill={color}
      />
    </svg>
  );
};

export default Send;
